'use strict';
const angular = require('angular');

export class combinedDateTimePickerComponent {

  constructor() {
    'ngInject';
  }

  $onInit() {
    this.datetime = moment(this.model).toDate();
  }

  dateChange() {
  }
}

export default angular.module('conduuApp.combinedDateTimePicker', [])
  .component('combinedDateTimePicker', {
    template: require('./combined-date-time-picker.component.html'),
    bindings: {
      model: "=",
      form: "<"
    },
    controller: combinedDateTimePickerComponent
  })
  .name;



// WEBPACK FOOTER //
// ./client/components/combined-date-time-picker/combined-date-time-picker.component.js